export const OutlookIcon = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_383_26254)">
      <path
        d="M23.9997 11.5499C24.001 11.365 23.904 11.1928 23.7441 11.0961H23.7413L23.7312 11.0906L15.415 6.23964C15.379 6.21573 15.3418 6.19387 15.3033 6.17419C14.9822 6.01095 14.6008 6.01095 14.2797 6.17419C14.2412 6.19389 14.204 6.21573 14.1681 6.23964L5.85181 11.0906L5.84177 11.0961C5.5876 11.2519 5.50968 11.5812 5.66774 11.8317C5.71431 11.9055 5.77845 11.9669 5.8546 12.0108L14.1709 16.8618C14.2069 16.8855 14.2442 16.9073 14.2825 16.9272C14.6036 17.0905 14.985 17.0905 15.3061 16.9272C15.3445 16.9073 15.3817 16.8855 15.4178 16.8618L23.734 12.0108C23.9002 11.9153 24.0016 11.7394 23.9997 11.5499Z"
        fill="#0A2767"
      />
      <path
        d="M6.82144 8.311H12.2789V13.2406H6.82144V8.311ZM22.8836 3.29995V1.04495C22.8967 0.481145 22.4438 0.013462 21.8717 -4.79562e-05H7.70945C7.13731 0.013462 6.68444 0.481145 6.69754 1.04495V3.29995L15.0696 5.49994L22.8836 3.29995Z"
        fill="#0364B8"
      />
      <path
        d="M6.69727 3.30005H12.2787V8.25004H6.69727V3.30005Z"
        fill="#0078D4"
      />
      <path
        d="M17.8607 3.29995H12.2793V8.24995L17.8607 13.1999H22.8839V8.24995L17.8607 3.29995Z"
        fill="#28A8EA"
      />
      <path
        d="M12.2793 8.24995H17.8607V13.1999H12.2793V8.24995Z"
        fill="#0078D4"
      />
      <path d="M12.2793 13.2H17.8607V18.1499H12.2793V13.2Z" fill="#0364B8" />
      <path
        d="M6.82129 13.2407H12.2788V17.7221H6.82129V13.2407Z"
        fill="#14447D"
      />
      <path d="M17.8604 13.2H22.8836V18.1499H17.8604V13.2Z" fill="#0078D4" />
      <path
        d="M23.744 11.9807L23.7334 11.9862L15.4171 16.5952C15.3809 16.6172 15.344 16.6381 15.3055 16.6568C15.1643 16.7231 15.0108 16.7605 14.8545 16.7668L14.4002 16.505C14.3618 16.486 14.3245 16.4649 14.2886 16.4417L5.86068 11.7018H5.85677L5.58105 11.55V20.8802C5.58535 21.5027 6.10079 22.004 6.73249 22H22.8661C22.8755 22 22.8839 21.9956 22.894 21.9956C23.0274 21.9872 23.1589 21.9602 23.2847 21.9153C23.339 21.8927 23.3914 21.8658 23.4415 21.835C23.4789 21.8141 23.5431 21.7685 23.5431 21.7685C23.829 21.56 23.9982 21.2308 23.9996 20.8803V11.55C23.9994 11.7285 23.9018 11.8931 23.744 11.9807Z"
        fill="url(#paint0_linear_383_26254)"
      />
      <path
        opacity="0.5"
        d="M23.5537 11.5131V12.0851L14.8579 17.9849L5.85506 11.7056C5.85506 11.7026 5.85256 11.7001 5.84948 11.7001L5.02344 11.2106V10.7981L5.3639 10.7926L6.0839 11.1996L6.10063 11.2051L6.16203 11.2436C6.16203 11.2436 14.6234 16.0011 14.6457 16.0121L14.9695 16.1991C14.9974 16.1881 15.0253 16.1771 15.0588 16.1661C15.0755 16.1551 23.4587 11.5076 23.4587 11.5076L23.5537 11.5131Z"
        fill="#0A2767"
      />
      <path
        d="M23.744 11.9807L23.7334 11.9867L15.4171 16.5957C15.3808 16.6177 15.344 16.6386 15.3055 16.6573C14.9825 16.8128 14.6048 16.8128 14.2819 16.6573C14.2436 16.6387 14.2064 16.6181 14.1702 16.5957L5.85398 11.9867L5.84394 11.9807C5.68338 11.8949 5.58272 11.73 5.58105 11.55V20.8802C5.58505 21.5026 6.1003 22.004 6.73189 22C6.73189 22 6.73191 22 6.73194 22H22.8488C23.4804 22.004 23.9956 21.5027 23.9996 20.8803C23.9996 20.8803 23.9996 20.8803 23.9996 20.8802V11.55C23.9994 11.7285 23.9018 11.8931 23.744 11.9807Z"
        fill="#1490DF"
      />
      <path
        opacity="0.1"
        d="M15.5381 16.5273L15.4136 16.5961C15.3775 16.6187 15.3403 16.6395 15.302 16.6582C15.1648 16.7246 15.0157 16.7635 14.8633 16.7726L18.0274 20.4598L23.5468 21.7705C23.6981 21.6579 23.8184 21.5099 23.8968 21.3398L15.5381 16.5273Z"
        fill="black"
      />
      <path
        opacity="0.05"
        d="M16.1018 16.2151L15.4136 16.5962C15.3775 16.6189 15.3403 16.6396 15.302 16.6584C15.1648 16.7247 15.0157 16.7636 14.8633 16.7728L16.3457 20.8004L23.5485 21.769C23.8322 21.559 23.9993 21.2298 23.9995 20.8802V20.7597L16.1018 16.2151Z"
        fill="black"
      />
      <path
        d="M6.74756 22H22.8471C23.0948 22.0013 23.3364 21.9242 23.5364 21.78L14.3996 16.5061C14.3613 16.4871 14.324 16.466 14.288 16.4429L5.86012 11.7029H5.85621L5.58106 11.55V20.8483C5.58043 21.4838 6.10269 21.9994 6.74756 22Z"
        fill="#28A8EA"
      />
      <path
        opacity="0.1"
        d="M13.395 5.40805V17.1395C13.394 17.5509 13.1402 17.9206 12.7531 18.0745C12.6332 18.1253 12.5041 18.1515 12.3736 18.1516H5.58105V4.9499H6.69734V4.3999H12.3736C12.9375 4.40201 13.3938 4.85241 13.395 5.40805Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.8369 5.95814V17.6896C12.8383 17.8225 12.8097 17.954 12.7531 18.0746C12.5981 18.4511 12.2278 18.6981 11.8155 18.7H5.58105V4.95H11.8155C11.9774 4.9484 12.137 4.9882 12.2787 5.0655C12.6209 5.23536 12.8367 5.58063 12.8369 5.95814Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.8369 5.95814V16.5896C12.8341 17.145 12.3791 17.5952 11.8155 17.6H5.58105V4.95H11.8155C11.9774 4.9484 12.137 4.9882 12.2787 5.0655C12.6209 5.23536 12.8367 5.58063 12.8369 5.95814Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M12.2787 5.9581V16.5896C12.2781 17.1458 11.8218 17.5972 11.2573 17.5999H5.58105V4.94995H11.2573C11.8217 4.95025 12.279 5.40137 12.2787 5.95755C12.2787 5.95774 12.2787 5.95792 12.2787 5.9581Z"
        fill="black"
      />
      <path
        d="M1.02307 4.94995H11.256C11.821 4.94995 12.2791 5.40132 12.2791 5.9581V16.0418C12.2791 16.5986 11.821 17.0499 11.256 17.0499H1.02307C0.458037 17.0499 0 16.5986 0 16.0418V5.9581C0 5.40132 0.45805 4.94995 1.02307 4.94995Z"
        fill="url(#paint1_linear_383_26254)"
      />
      <path
        d="M3.1973 9.17833C3.44946 8.64894 3.85645 8.20591 4.36605 7.90619C4.9304 7.5878 5.57296 7.42908 6.22299 7.44748C6.82545 7.4346 7.41993 7.5851 7.94149 7.88253C8.43188 8.1707 8.82683 8.59295 9.07842 9.09802C9.35241 9.65457 9.48896 10.2671 9.47694 10.8855C9.49022 11.5319 9.34972 12.1723 9.0667 12.7555C8.80912 13.2786 8.40164 13.7159 7.89461 14.0134C7.35294 14.3199 6.73639 14.4744 6.11192 14.46C5.49658 14.4746 4.889 14.3224 4.35545 14.02C3.86082 13.7314 3.46091 13.3087 3.20345 12.8023C2.92784 12.2538 2.78966 11.6482 2.80048 11.0362C2.789 10.3954 2.92465 9.76026 3.1973 9.17833ZM4.44307 12.1648C4.57751 12.4995 4.80549 12.7898 5.10056 13.0019C5.4011 13.2089 5.76098 13.3157 6.12753 13.3066C6.51789 13.3218 6.90267 13.2114 7.22372 12.992C7.51505 12.7805 7.73704 12.4895 7.86222 12.1549C8.00217 11.7813 8.07123 11.3855 8.06595 10.9873C8.07027 10.5852 8.00535 10.1854 7.87394 9.80478C7.75788 9.46113 7.54304 9.15809 7.25553 8.93248C6.94253 8.70271 6.55879 8.58617 6.16883 8.60248C5.79434 8.59292 5.4264 8.70055 5.11786 8.90993C4.8178 9.12299 4.58549 9.41582 4.44809 9.75417C4.14329 10.5298 4.1417 11.3893 4.44362 12.1659L4.44307 12.1648Z"
        fill="white"
      />
      <path
        d="M17.8604 3.29995H22.8836V8.24995H17.8604V3.29995Z"
        fill="#50D9FF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_383_26254"
        x1="14.7904"
        y1="11.5501"
        x2="14.7904"
        y2="22.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35B8F1" />
        <stop offset="1" stopColor="#28A8EA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_383_26254"
        x1="2.13312"
        y1="4.16221"
        x2="9.97067"
        y2="17.9374"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1784D9" />
        <stop offset="0.5" stopColor="#107AD5" />
        <stop offset="1" stopColor="#0A63C9" />
      </linearGradient>
      <clipPath id="clip0_383_26254">
        <rect width="24" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
